const PageBiReports = () => import('./PageBiReports');
import * as children from './pages/**/routes.js'; //eslint-disable-line

export default {
  path: 'bi-reports',
  children: {
    biReports: {
      name: 'bi-reports',
      path: '',
      component: PageBiReports,
      meta: {
        title: 'Relatórios Customizados',
      },
    },
    ...children,
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/bi-reports/routes.js